import React from "react";
import { ParticipantCard } from "./ParticipantCard";

export function FundraiserTeam({ participants = [], fundraiserSlug, fundraiserTitle }) {
  if (!participants || participants.length === 0) {
    return null;
  }

  return (
    <section className="bg-white py-16">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-orange-500 relative inline-block">
            Meet Our Team
            <div className="h-1 w-full bg-orange-500 mt-2"></div>
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Support an individual player on their journey. Every player has
            their own goal to reach.
          </p>
        </div>

        <div className="max-w-5xl mx-auto px-2 sm:px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {participants.map((participant) => (
              <ParticipantCard
                key={participant.slug}
                participant={participant}
                fundraiserSlug={fundraiserSlug}
                fundraiserTitle={fundraiserTitle}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
